import httpClient from "./httpClient";

export const getWorkDetails = async () => {
  return await httpClient.get("/api/work");
};
